import { render, staticRenderFns } from "./cfdi.vue?vue&type=template&id=cd9493fc&"
import script from "./cfdi.vue?vue&type=script&lang=js&"
export * from "./cfdi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports